import { Component, OnInit, Input, AfterViewInit, AfterContentInit } from '@angular/core';
import { InteractionsService } from 'src/app/services/interactions.service';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit, AfterContentInit {

  @Input('content') content;
  @Input('interaction') interaction;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterContentInit() {
    if (this.interaction) {
      this.content = this.interaction.content;
    }

  }
}
